import React, { Component } from 'react'
import { Row, Col, Button, Container } from 'react-bootstrap';
import * as Cookies from "es-cookie";
import { components } from 'react-select';
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import './_attendanceReport.scss';
import moment from 'moment';


class excelContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mainTableStartDate: moment.unix(this.props.stateData.startDateCalender).format("DD-MM-YYYY"),
      mainTableEndDate: moment.unix(this.props.stateData.endDateCalender).format("DD-MM-YYYY")
    }
  }


  render() {
    console.log("stateDatastateData", this.props.stateData)
    let presentAndAbsent = [{ status: "Present" }, { status: "Absent" }, { status: "Sick" }];

    return (
      <>
        <ReactHTMLTableToExcel
          id="test-table-xls-button"
          className="btn text-uppercase  downlaod_btn download_btn_color"
          table="table-to-xls"
          filename="Student_Attendance_report"
          sheet="Student_Attendance_report"
          buttonText="DOWNLOAD LIST"
        />
        <table id="table-to-xls" style={{ display: "none" }}>
          <thead>
            <tr>
              <th style={{ color: "#000", fontSize: "15px", width: "250px" }} rowSpan="2">Date</th>
              <th style={{ color: "#000", width: "300px", fontSize: "15px" }} rowSpan="2">Class/Exam/Section</th>
              {
                this.props.attendanceTypes.map((item) => {
                  return (<th style={{ color: "#000", width: "100px", fontSize: "15px" }} colSpan="3">{item.label}</th>
                  )
                })
              }
            </tr>
            <tr>
              {
                this.props.attendanceTypes.map((item) => {
                  return (

                    presentAndAbsent.map((item1) => {
                      return (<th style={{ color: "#000", width: "100px", fontSize: "15px" }} rowSpan="1">{item1.status}</th>
                      )
                    })
                  )

                })
              }
            </tr>
          </thead>
          <tbody>
            {
              this.props.stateData.attendanceData.map(item => {
                console.log("datasss", item.data);
                let date = moment.unix(item.date).format("DD-MM-YYYY")
                return (
                  <tr>
                    <td style={{ textAlign: "center", fontSize: "15px" }}>{this.state.mainTableStartDate + "   To   " + this.state.mainTableEndDate}</td>
                    <td style={{ textAlign: "center", fontSize: "15px" }}>{item.ces}</td>
                    {
                      item.data != null ? (

                        this.props.attendanceTypes.map((item1) => {
                          let data = item.data.filter((item2) => item1.value == item2.attendance_subtype_id);

                          if (data.length > 0) {
                            return (
                              <>
                                <td style={{ textAlign: "center", fontSize: "15px" }}>{data[0].present}</td>
                                <td style={{ textAlign: "center", fontSize: "15px" }}>{data[0].absent}</td>
                                <td style={{ textAlign: "center", fontSize: "15px" }}>{data[0].sick}</td>
                              </>
                            )
                          } else {
                            return (
                              <>
                                <td style={{ textAlign: "center", fontSize: "15px" }}>-</td>
                                <td style={{ textAlign: "center", fontSize: "15px" }}>-</td>
                                <td style={{ textAlign: "center", fontSize: "15px" }}>-</td>
                              </>
                            )
                          }
                        })
                      ) : (

                        this.props.attendanceTypes.map((item) => {
                          return (
                            <>
                              <td style={{ textAlign: "center", fontSize: "15px" }}>-</td>
                              <td style={{ textAlign: "center", fontSize: "15px" }}>-</td>
                              <td style={{ textAlign: "center", fontSize: "15px" }}>-</td>
                            </>
                          )

                        })

                      )
                    }
                  </tr>
                )
              })
            }
          </tbody>
        </table>
      </>
    )
  }
}

export default excelContainer;



